// extracted by mini-css-extract-plugin
var _1 = "ColleagueLoads-moduleColleagueLoads__JdSEx";
export { _1 as "ColleagueLoads" }
